import { Middleware } from '@reduxjs/toolkit';

// Block every RTK Query mutation while the user is browsing in demo mode.
// Belt-and-braces: demo-mode routing already hides write surfaces, but if any
// stray dispatch leaks through (e.g. a kept-mounted component, a rehydrated
// action), it shouldn't hit the server.
//
// `Middleware` is left unparameterised on purpose: typing the State generic as
// `RootState` would create a cyclic type (store → middleware tuple → store) and
// trip TS2502 "referenced directly or indirectly in its own type annotation".
// The state shape is read defensively via narrow optional access instead.
export const demoGuardMiddleware: Middleware =
  (storeApi) => (next) => (action) => {
    const type = (action as { type?: string })?.type;
    if (typeof type === 'string' && type.endsWith('/executeMutation/pending')) {
      const state = storeApi.getState() as { demo?: { isDemo?: boolean } };
      if (state.demo?.isDemo) {
        return next({
          ...(action as object),
          type: type.replace('/pending', '/rejected'),
          error: { message: 'demo-mode: read-only' },
          meta: {
            ...((action as any).meta ?? {}),
            condition: false,
            rejectedWithValue: true,
          },
        } as any);
      }
    }
    return next(action);
  };
